import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DailyReportService } from '../../../../daily-report.service';

@Component({
    selector: 'app-internal-test-details-wrapper',
    templateUrl: './internal-test-details-wrapper.component.html',
    styleUrls: ['./internal-test-details-wrapper.component.scss'],
    standalone: false
})
export class InternalTestDetailsWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  disableAddMenu = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private dailyReportService: DailyReportService,
    private cdRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.dailyReportService.disableAddMenu
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d) => {
        this.disableAddMenu = d;
        this.cdRef.detectChanges();
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
